import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetRoundTripDataRequest extends BaseServiceRequest {
  constructor(portfolioID, osid, startDate, endDate, getlong, getshort, currencyCode) {
    super();
    super.addRequestUri("getroundtripschartdata");
    super.setContent({
      "benchmarkId": -1,
      "portfolioIds": portfolioID.toString(),
      "osid": osid,
      "periodicity": 1,
      "startDate": startDate,
      "endDate": endDate,
      "long": getlong,
      "short": getshort,
      "currencyCode": currencyCode,
    });
  }

  getMethod() {
    return HttpMethodType.POST;
  }

  getSubSystem() {
    return SubSystemType.ACCOUNT_ANALYZER;
  }

  // getMessageName() {
  //   return "TransactionsResponseData";
  // }
}

export default GetRoundTripDataRequest;
